<template>
	<div class="user-wrapper">
		<!-- @click="popUpProfileVisible = !popUpProfileVisible" -->
		<button
			class="user-container"
		>
			<div v-if="this.$store.state.user.first_name">
				{{ this.$store.state.user.first_name.charAt(0)
				}}{{ this.$store.state.user.last_name.charAt(0) }}
			</div>
			<div v-else>JD</div>
		</button>
		<pop-up-profile
			@close="popUpProfileVisible = !popUpProfileVisible"
			v-if="popUpProfileVisible"
		/>
		<router-link class="user__link" to="/admin/profil">
			<div class="user__infos">
				<div class="user__display">{{ this.$store.state.user.first_name }} {{ this.$store.state.user.last_name }}</div>
				<div class="user__label">Voir mon profil</div>
			</div>
		</router-link>
		<img
			src="/img/setting.svg"
			alt="" 
			class="user__setting">
	</div>
</template>

<script>
import PopUpProfile from "../PopUp/PopUpProfile.vue"
export default {
	components: { PopUpProfile },
	data() {
		return {
			popUpProfileVisible: false
		}
	},
}
</script>

<style>
</style>
